import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StepRRSSTercerTiempo from '../../components/tercertiempo/StepRRSSTercerTiempo';
import { crearTercerTiempo } from '../../services/api';

const PASOS = [
  { num: 1, label: 'Cuenta'  },
  { num: 2, label: 'Negocio' },
  { num: 3, label: 'RRSS'    },
];

const ZONAS = [
  'Machalí', 'Rancagua', 'Sewell', 'Graneros',
  'Mostazal', 'Coinco', 'Coltauco', 'Doñihue',
  'Las Cabras', 'Peumo', 'Pichidegua', 'San Vicente',
];

function StepCuentaTercerTiempo({ datos, onNext }) {
  const [form, setForm] = useState({
    nombre:   datos.nombre   || '',
    email:    datos.email    || '',
    celular:  datos.celular  || '',
    password: datos.password || '',
  });
  const [errores, setErrores] = useState({});

  const actualizar = (campo, valor) => {
    setForm(prev => ({ ...prev, [campo]: valor }));
    setErrores(prev => ({ ...prev, [campo]: '' }));
  };

  const handleNext = () => {
    const e = {};
    if (!form.nombre.trim())       e.nombre   = 'Ingresa tu nombre';
    if (!form.email.includes('@')) e.email    = 'Email inválido';
    if (form.celular.length < 8)   e.celular  = 'Celular inválido';
    if (form.password.length < 6)  e.password = 'Mínimo 6 caracteres';
    if (Object.keys(e).length > 0) { setErrores(e); return; }
    onNext(form);
  };

  return (
    <div>
      <div style={s.titulo}>🍺 Tu cuenta de proveedor</div>
      <p style={s.sub}>Crea tu cuenta para ofrecer servicios de Tercer Tiempo en TuRival.</p>
      {[
        { campo: 'nombre',   label: 'Nombre completo',  placeholder: 'Juan Pérez',          type: 'text'     },
        { campo: 'email',    label: 'Email',             placeholder: 'juan@email.cl',       type: 'email'    },
        { campo: 'celular',  label: 'Celular',           placeholder: '+56 9 1234 5678',     type: 'text'     },
        { campo: 'password', label: 'Contraseña',        placeholder: 'Mínimo 6 caracteres', type: 'password' },
      ].map(({ campo, label, placeholder, type }) => (
        <div key={campo} style={{ marginBottom: 16 }}>
          <label style={s.label}>{label}</label>
          <input
            type={type}
            value={form[campo]}
            onChange={e => actualizar(campo, e.target.value)}
            placeholder={placeholder}
            style={{ ...s.input, borderColor: errores[campo] ? '#EF4444' : '#E8ECF4' }}
          />
          {errores[campo] && <span style={s.error}>{errores[campo]}</span>}
        </div>
      ))}
      <button onClick={handleNext} style={s.btnNext}>Siguiente →</button>
    </div>
  );
}

function StepNegocioTercerTiempo({ datos, onNext, onBack }) {
  const [form, setForm] = useState({
    negocio:     datos.negocio     || '',
    zona:        datos.zona        || '',
    descripcion: datos.descripcion || '',
    tieneLocal:  datos.tieneLocal  || false,
    aDomicilio:  datos.aDomicilio  || false,
  });
  const [error, setError] = useState('');

  const actualizar = (campo, valor) => {
    setForm(prev => ({ ...prev, [campo]: valor }));
    setError('');
  };

  const handleNext = () => {
    if (!form.negocio.trim()) { setError('Ingresa el nombre de tu negocio'); return; }
    if (!form.zona)           { setError('Selecciona tu zona');              return; }
    if (!form.tieneLocal && !form.aDomicilio) {
      setError('Selecciona al menos una modalidad de servicio');
      return;
    }
    onNext(form);
  };

  return (
    <div>
      <div style={s.titulo}>🏠 Tu negocio</div>
      <p style={s.sub}>Cuéntanos cómo operas para que los equipos sepan qué esperar.</p>

      <div style={{ marginBottom: 16 }}>
        <label style={s.label}>Nombre del negocio</label>
        <input
          value={form.negocio}
          onChange={e => actualizar('negocio', e.target.value)}
          placeholder="Ej: Asados Don Pepe, El Rincón del Asado..."
          style={{ ...s.input, borderColor: error && !form.negocio ? '#EF4444' : '#E8ECF4' }}
        />
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={s.label}>Zona donde operas</label>
        <select
          value={form.zona}
          onChange={e => actualizar('zona', e.target.value)}
          style={{ ...s.input, background: 'white', borderColor: error && !form.zona ? '#EF4444' : '#E8ECF4' }}
        >
          <option value="">Selecciona tu zona</option>
          {ZONAS.map(z => <option key={z}>{z}</option>)}
        </select>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={s.label}>Descripción del servicio (opcional)</label>
        <textarea
          value={form.descripcion}
          onChange={e => actualizar('descripcion', e.target.value)}
          placeholder="Ej: Asados completos, cervezas y empanadas para ambos equipos al finalizar el partido..."
          style={{ ...s.input, resize: 'none', height: 80 }}
          maxLength={300}
        />
        <span style={{ fontSize: 11, color: '#9BA5B7', float: 'right', fontFamily: "'Barlow', sans-serif" }}>
          {form.descripcion.length}/300
        </span>
      </div>

      <div style={{ marginBottom: 16 }}>
        <label style={s.label}>¿Cómo ofreces el servicio?</label>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          {[
            { key: 'tieneLocal', icono: '🏠', label: 'Tengo local propio',    desc: 'Los equipos vienen a tu espacio' },
            { key: 'aDomicilio', icono: '🚗', label: 'Servicio a domicilio',  desc: 'Llevas todo al recinto deportivo' },
          ].map(({ key, icono, label, desc }) => (
            <div
              key={key}
              onClick={() => actualizar(key, !form[key])}
              style={{
                borderRadius: 12, padding: '14px',
                cursor: 'pointer', textAlign: 'center',
                border: `2px solid ${form[key] ? '#FF6B1A' : '#E8ECF4'}`,
                background: form[key] ? '#FFF7ED' : 'white',
                position: 'relative',
              }}
            >
              <div style={{ fontSize: 28, marginBottom: 6 }}>{icono}</div>
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: 14, fontWeight: 700, color: '#141922', marginBottom: 4 }}>{label}</div>
              <div style={{ fontSize: 11, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" }}>{desc}</div>
              {form[key] && (
                <div style={{ position: 'absolute', top: 8, right: 8, background: '#FF6B1A', color: 'white', width: 18, height: 18, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 10, fontWeight: 700 }}>✓</div>
              )}
            </div>
          ))}
        </div>
      </div>

      {error && <p style={s.error}>{error}</p>}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10 }}>
        <button onClick={onBack} style={s.btnBack}>← Atrás</button>
        <button onClick={handleNext} style={s.btnNext}>Siguiente →</button>
      </div>
    </div>
  );
}

export default function RegistroTercerTiempo() {
  const navigate   = useNavigate();
  const [paso,     setPaso]     = useState(1);
  const [datos,    setDatos]    = useState({});
  const [cargando, setCargando] = useState(false);
  const [error,    setError]    = useState('');

  const handleNext = (datosPaso) => {
    const actualizados = { ...datos, ...datosPaso };
    setDatos(actualizados);
    if (paso < 3) {
      setPaso(paso + 1);
    } else {
      finalizar(actualizados);
    }
  };

  const handleBack = () => {
    if (paso > 1) setPaso(paso - 1);
  };

  const finalizar = async (datosFinales) => {
    setCargando(true);
    setError('');
    try {
      const rrss = datosFinales.rrss || {};
      const data = await crearTercerTiempo({
        nombre:      datosFinales.nombre,
        email:       datosFinales.email,
        celular:     datosFinales.celular,
        password:    datosFinales.password,
        negocio:     datosFinales.negocio     || '',
        zona:        datosFinales.zona        || '',
        descripcion: datosFinales.descripcion || null,
        tiene_local: datosFinales.tieneLocal  || false,
        a_domicilio: datosFinales.aDomicilio  || false,
        servicios:   [],
        instagram:   rrss.instagram || null,
        facebook:    rrss.facebook  || null,
        tiktok:      rrss.tiktok    || null,
        whatsapp:    rrss.whatsapp  || null,
      });

      if (data.error) { setError(data.error); return; }
      navigate('/login');
    } catch {
      setError('Error de conexión. Intenta de nuevo.');
    } finally {
      setCargando(false);
    }
  };

  return (
    <div style={styles.pagina}>
      <div style={styles.container}>

        <div style={styles.logo}>
          Tu<span style={styles.logoSpan}>Rival</span>
          <span style={styles.logoSub}> · Tercer Tiempo</span>
        </div>

        <div style={styles.stepper}>
          {PASOS.map(({ num, label }, i) => {
            const completado = paso > num;
            const activo     = paso === num;
            return (
              <div key={num} style={styles.stepItem}>
                <div style={{
                  ...styles.stepCirculo,
                  background: completado ? '#16A34A' : activo ? '#FF6B1A' : 'rgba(255,255,255,0.1)',
                  border: activo ? '2px solid #FF6B1A' : completado ? '2px solid #16A34A' : '2px solid rgba(255,255,255,0.15)',
                }}>
                  <span style={{ color: completado || activo ? 'white' : 'rgba(255,255,255,0.3)', fontSize: 12, fontWeight: 700, fontFamily: "'Barlow Condensed', sans-serif" }}>
                    {completado ? '✓' : num}
                  </span>
                </div>
                <span style={{ fontSize: 10, fontWeight: 600, color: activo ? 'white' : 'rgba(255,255,255,0.3)', fontFamily: "'Barlow', sans-serif", textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                  {label}
                </span>
                {i < PASOS.length - 1 && (
                  <div style={{ ...styles.stepLinea, background: completado ? '#16A34A' : 'rgba(255,255,255,0.1)' }} />
                )}
              </div>
            );
          })}
        </div>

        {error && <div style={styles.errorBanner}>{error}</div>}

        <div style={styles.card}>
          {paso === 1 && <StepCuentaTercerTiempo datos={datos} onNext={handleNext} />}
          {paso === 2 && <StepNegocioTercerTiempo datos={datos} onNext={handleNext} onBack={handleBack} />}
          {paso === 3 && <StepRRSSTercerTiempo datos={datos} onNext={handleNext} onBack={handleBack} cargando={cargando} />}
        </div>

        <p style={styles.linkEquipos}>
          ¿Eres capitán de un equipo?{' '}
          <span style={styles.link} onClick={() => navigate('/registro')}>Regístrate aquí</span>
        </p>
      </div>
    </div>
  );
}

// Estilos internos compartidos entre steps
const s = {
  titulo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 4 },
  sub: { fontSize: 13, color: '#6B7280', fontFamily: "'Barlow', sans-serif", marginBottom: 24, lineHeight: 1.5 },
  label: { display: 'block', fontSize: 11, fontWeight: 700, color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6, fontFamily: "'Barlow', sans-serif" },
  input: { width: '100%', padding: '11px 14px', border: '1.5px solid #E8ECF4', borderRadius: 10, fontSize: 13, color: '#141922', fontFamily: "'Barlow', sans-serif", outline: 'none', boxSizing: 'border-box' },
  error: { display: 'block', fontSize: 11, color: '#EF4444', marginTop: 4, fontFamily: "'Barlow', sans-serif" },
  btnNext: { width: '100%', padding: '13px', background: '#FF6B1A', border: 'none', borderRadius: 12, fontFamily: "'Barlow Condensed', sans-serif", fontSize: 17, fontWeight: 800, color: 'white', cursor: 'pointer', marginTop: 8 },
  btnBack: { padding: '13px', background: 'white', border: '1.5px solid #E8ECF4', borderRadius: 12, fontSize: 14, fontWeight: 700, color: '#6B7280', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif" },
};

const styles = {
  pagina: { minHeight: '100vh', background: '#0D1117', padding: '32px 20px', display: 'flex', alignItems: 'flex-start', justifyContent: 'center' },
  container: { width: '100%', maxWidth: 560 },
  logo: { fontFamily: "'Barlow Condensed', sans-serif", fontSize: 28, fontWeight: 800, color: 'white', textAlign: 'center', marginBottom: 24, letterSpacing: '-0.02em' },
  logoSpan: { color: '#FF6B1A' },
  logoSub: { fontSize: 16, fontWeight: 500, color: 'rgba(255,255,255,0.3)' },
  stepper: { display: 'flex', alignItems: 'flex-start', justifyContent: 'center', marginBottom: 24, padding: '0 10px' },
  stepItem: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5, position: 'relative', flex: 1 },
  stepCirculo: { width: 32, height: 32, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1, transition: 'all 0.2s' },
  stepLinea: { position: 'absolute', top: 16, left: '50%', width: '100%', height: 2, zIndex: 0, transition: 'background 0.2s' },
  errorBanner: { background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: 10, padding: '10px 16px', fontSize: 13, color: '#EF4444', fontFamily: "'Barlow', sans-serif", marginBottom: 16, textAlign: 'center' },
  card: { background: 'white', borderRadius: 20, padding: '32px', marginBottom: 16 },
  linkEquipos: { textAlign: 'center', fontSize: 13, color: 'rgba(255,255,255,0.3)', fontFamily: "'Barlow', sans-serif" },
  link: { color: '#1A6BFF', cursor: 'pointer', fontWeight: 600 },
};